import { FETCH_VM_TEMPLATE_NAME_LIST } from "../../constants/action.constants";

const initialState = {
  list: [],
};

const vmTemplateListDropdown = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_VM_TEMPLATE_NAME_LIST:
      return { list: action.payload };
    default:
      return state;
  }
};

export default vmTemplateListDropdown;
